import { Alert, Col, Row } from "reactstrap";
import {
    calcularRiesgoInherenteConsolidado,
    calcularPromedioEficaciaControles,
    calcularRiesgoResidualInstitucional,
    diagnosticarRiesgoResidual,
    formatearPuntaje,
    UMBRAL_RIESGO_RESIDUAL_BAJO
} from "./utils";

export default function CalculadorRiesgo({ riesgoInherente, mitigantes }) {
    const riesgoInherenteConsolidado = calcularRiesgoInherenteConsolidado(riesgoInherente);
    const promedioEficacia = calcularPromedioEficaciaControles(mitigantes);
    const riesgoResidual = calcularRiesgoResidualInstitucional(riesgoInherenteConsolidado, promedioEficacia);
    const diagnostico = diagnosticarRiesgoResidual(riesgoResidual);

    const alertColor = diagnostico?.nivel === 'BAJO' ? 'success' : diagnostico ? 'warning' : 'secondary';

    return (
        <div className="mb-4 p-3 border rounded">
            <h5>Resultado de riesgo institucional</h5>
            <p className="text-muted small mb-3">
                Riesgo Residual Institucional = Riesgo Inherente Consolidado × (1 − Promedio de eficacia de controles)
            </p>
            <Row className="mb-2">
                <Col md={6}>
                    <strong>Riesgo inherente consolidado:</strong> {formatearPuntaje(riesgoInherenteConsolidado)}
                </Col>
                <Col md={6}>
                    <strong>Promedio de eficacia de controles:</strong>{' '}
                    {promedioEficacia === null ? '—' : `${formatearPuntaje(promedioEficacia)}%`}
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <strong>Riesgo residual institucional:</strong> {formatearPuntaje(riesgoResidual)}
                    {riesgoResidual !== null && (
                        <span className="text-muted small"> (umbral bajo: &lt; {UMBRAL_RIESGO_RESIDUAL_BAJO})</span>
                    )}
                </Col>
            </Row>

            {riesgoInherenteConsolidado === null && (
                <p className="text-muted small mb-0">Completa la sección 2 para calcular el riesgo inherente.</p>
            )}
            {riesgoInherenteConsolidado !== null && promedioEficacia === null && (
                <p className="text-muted small mb-0">Completa la sección 3 para calcular el riesgo residual.</p>
            )}

            {diagnostico && (
                <Alert color={alertColor} className="mb-0">
                    <strong>Diagnóstico — Riesgo residual {diagnostico.nivel}:</strong> {diagnostico.descripcion}
                </Alert>
            )}
        </div>
    );
}
